import { loading, success, handleErrorException } from 'State/actions';
import { isRequestCancelation } from 'Common/Helpers';

import * as types from './types';

export const searchRecipes = ({ newSearch, ...searchParams }) => async (
  dispatch,
  getState,
  MPWWebApi
) => {
  try {
    const { Api, source } = MPWWebApi.createCancelableApi();

    dispatch(loading(types.GET_RECIPES, true, true, source));
    const response = await Api.postGenericInsertUpdate(
      'Recipe/GetRecipeSearchResults',
      searchParams
    );

    if (newSearch) {
      dispatch(success(types.SET_RECIPES, response.data.Data));
    } else {
      dispatch(success(types.APPEND_RECIPES, response.data.Data));
    }
    dispatch(loading(types.GET_RECIPES, false));
  } catch (ex) {
    dispatch(
      handleErrorException(ex, types.GET_RECIPES_ERROR, {
        Title: 'Error',
        Message: 'Could not load recipes.',
      })
    );

    if (!isRequestCancelation(ex)) {
      dispatch(loading(types.GET_RECIPES, false));
    }
  }
};

export const searchPrepRecipes = searchParams => async (
  dispatch,
  getState,
  MPWWebApi
) => {
  try {
    const { Api, source } = MPWWebApi.createCancelableApi();

    dispatch(loading(types.GET_RECIPES, true, true, source));
    const response = await Api.postGenericInsertUpdate(
      'Recipe/GetRecipePrepSearchResults',
      searchParams
    );
    dispatch(success(types.SET_RECIPES, response.data.Data));
    dispatch(loading(types.GET_RECIPES, false));
  } catch (ex) {
    dispatch(
      handleErrorException(ex, types.GET_RECIPES_ERROR, {
        Title: 'Error',
        Message: 'Could not load recipes.',
      })
    );

    if (!isRequestCancelation(ex)) {
      dispatch(loading(types.GET_RECIPES, false));
    }
  }
};

export const reset = () => ({
  type: types.RESET_RECIPE_STATE,
});

export const clearRecipes = () => ({
  type: types.CLEAR_RECIPES,
});

export const setPageSize = pageSize => ({
  type: types.SET_PAGE_SIZE,
  payload: pageSize,
});



// WEBPACK FOOTER //
// ./src/common/Components/RecipeSearch/state/actions.js